import React, {useRef, useEffect} from 'react';

function WebComponent({tagName, attrs = {}, events = {}, children}) {
  const ref = useRef();
  
  useEffect(() => {
    const {current: elem} = ref;
    
    const setupElement = async () => {
      try {
        await window.customElements.whenDefined(tagName);
        
        Object.keys(attrs).forEach((key) => {
          elem[key] = attrs[key];
        });
        
      } catch (error) {
        console.warn(`Failed to setup ${tagName}:`, error);
      }
    };

    const eventNames = Object.keys(events);
    eventNames.forEach((eventName) => {
      elem.addEventListener(eventName, events[eventName]);
    });

    setupElement();

    return () => {
      eventNames.forEach((eventName) => {
        elem.removeEventListener(eventName, events[eventName]);
      });
    };
  }, [ref, attrs, events, tagName]);

  return React.createElement(tagName, {ref}, children);
}

export default WebComponent;
